// extracted by mini-css-extract-plugin
module.exports = {"video":"RoboImageVideoPopup_video__3lVuI"};